/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useCallback, useContext, useState, useEffect
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import appConfig from 'app-config';
import classNames from 'classnames';

import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { UserService } from 'gw-capability-gateway';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLPupLineValidatorUtil,
    MLAvailableInsuredCandidatesUtil, MLWizardNavUtil ,MLExceptionErrorHandler
} from 'ml-portals-util-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLTooltipComponent, FormModalPopover, platformMessages as commonMessages } from 'ml-components-platform-react';
import { MLInsuredCandidatesComponent, MLNameDetailsComponent, MLAlertGroupComponent, SpousePopoverComponent } from 'ml-components-common-react';
import {
    AddExcludedDriverPopup, AddHouseholdMemberPopup, UnderlyingPolicyComponent
} from 'ml-capability-quoteandbind-common-react';

import PUMBTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import metadata from './VehicleDriverHouseHoldDetails.metadata.json5';
import messages from './VehicleDriverHouseHoldDetails.messages';
import styles from './VehicleDriverHouseHoldDetails.module.scss';
import PUPAddVehiclePopupComponent from '../../popups/PUPAddVehiclePopupComponent/PUPAddVehiclePopupComponent';
import addEditUnderlyingPolicyPopupMetadata from '../UnderlyingPolicies/AddEditUnderlyingPolicyPopup.metadata.json5';
import originalAddDriverMetadata from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/AddDriverPopup.metadata.json5';
import addDriverModalBodyStyles from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/AddDriverPopup.module.scss';

import removeDriverMetadata from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/RemoveDriverPopup.metadata.json5';
import removeDriverModalBodyStyles from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/RemoveDriverPopup.module.scss';
import { MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import {LoadSaveService} from "gw-capability-gateway-quoteandbind";
import { MLErrorMessageUtil } from 'ml-portals-util-js';
import { Link } from '@jutro/router';
import moment from 'moment';

import { IntlContext } from '@jutro/legacy/locale';

const ACTION_ADD_DRIVER = 'add';
const ACTION_REMOVE_DRIVER = 'remove';
const ACTION_EDIT_DRIVER = 'edit';
const UL_POLICY_CODES = {
    WATERCRAFT: 'PWL',
    HOME: 'HO',
    AUTO: 'PA',
    MOTORCYCLE: 'motorcycle_ml',
    RECREATIONAL_VEHICLE: 'recreational_vehicle_ml'
};

const VehicleDriverHouseHoldDetailsPage = (props) => {
    const modalApi = useModal();
    const isQnB = appConfig.portalCode === 'QB';
    const isGPA = appConfig.portalCode === 'GPA';
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData: submissionVM, updateWizardData, goNext, currentStep, isSkipping, steps, history
    } = props;
    const {
        onValidate
    } = useValidation('VehicleDriversHHMembersExposures');
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    // eslint-disable-next-line no-unused-vars
    const [recentlyAddedVehicle, updateRecentlyAddedVehicle] = useState(null);
    const [vehicleEditedOriginal, updateVehicleEditedOriginal] = useState(null);
    const [isVehiclePopupOpen, setVehiclePopupOpen] = useState(null);
    const [isEditVehiclePopupOpen, setEditVehiclePopupOpen] = useState(null);
    const [, updateRecentlyAddedDriver] = useState(null);
    const [, updateDriverEditedOriginal] = useState(null);
    const [clickedOnNext, updateClickedOnNext] = useState(false);
    const [addDriverMetadata, setAddDriverMetadata] = useState(_.cloneDeep(originalAddDriverMetadata));
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const returnToQuoteFlag = history?.location?.state?.returnToQuote || undefined;
    const MLAlertService = MLNotificationBlockUtil();

    const {
        clearAlerts,
        clearErrorAlerts,
        clearSuccessAlerts,
        clearBlockAlerts,
        addErrorAlert,
        addSuccessAlert,
        addWarningAlert
    } = MLNotificationBlockUtil();

    const {nextStepVisited, canShowReturnToQuoteButton, isLastStep} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const { handleExceptionErrors , clearExceptionErrors } = MLExceptionErrorHandler();

    const { validateVehicleDriverDetailsExposures } = MLPupLineValidatorUtil();

    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const vehicleOperatorsModel = _.get(submissionVM, 'lobData.value.personalUmbrella.coverables.vehicleOperators');
    const vehiclesModel = _.get(submissionVM, 'lobData.value.personalUmbrella.coverables.vehicles');
    const disableRemoveBtnForPNIFlagInUMP_Ext = pupModel?.coverables?.disableRemoveBtnForPNIFlagInUMP_Ext?.value ?? false

    const isInSync = false;
    const canExcludeDrivers = _.get(submissionVM, 'baseData.canExcludeDrivers_ML.value', false);
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const isUMB_NP = isPersonalUmbrella && isModernProduct;
    const isPolicyChange = false;
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    let returnToQuoteClicked = false;
    const ACCOUNTHOLDER_MIN_AGE = 18;

    const {
        validateVehicleAddition,
        readyVehicleForSave,
        isSamePerson,
        getFullName,
        getRatedDriverType,
        getHouseholdDriverType,
        getExcludedDriverType,
        getUmbrellaDriverNotListedReasonsForAdding,
        getFilteredGender,
        getRemoveDriverExcludedOptions,
        getUmbrellaDriverTypeNewProduct,
        getUmbrellaRemoveDriverOptions
    } = MLDriverVehicleUtil();

    const {
        filterAvailableUmbrellaInsuredCandidates,
        addRemovedVehicleOperatorToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const isExcludedDriver = ((type) => ['excluded'].includes(type));
    const isNonDriver = ((type) => ['nondriver', 'permitted', 'outofhousehold'].includes(type));
    const isHouseholdMember = ((type) => ['household'].includes(type));
    const isHouseholdMemberOrNonDriver = ((type) => isNonDriver(type) || isHouseholdMember(type));

    const _getDriverTypeDisplayName = (driverType, isSingular) => {
        let message;
        switch (driverType) {
            case 'rated':
                message = isSingular ? messages.Driver : messages.Drivers;
                break;
            case 'excluded':
                message = isSingular ? messages.ExcludedDriver : messages.ExcludedDrivers;
                break;
            case 'household':
                message = isSingular ? messages.HouseholdMember : messages.HouseholdMembers;
                break;
            case 'nondriver':
            case 'outofhousehold':
            case 'permit':
                message = isSingular ? messages.NonDriver : messages.NonDrivers;
                break;
            default:
                return;
        }
        if (message) {
            return translator(message);
        }
    };

    const checkForQuestionUwIssues = useCallback(() => {
        const uwIssues = submissionVM.errorsAndWarnings?.underwritingIssues?.value;
        if (uwIssues?.length > 0) {
            const questionCheckpointIssues = uwIssues.filter((issue) => {
                return issue.checkingSet_Ext === 'vehicle_exposure_ml' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            if (questionCheckpointIssues?.length > 0) {
                setIsUWIssuesPanelVisible(true);
                setBlockingUwIssues(questionCheckpointIssues);
                setDisableNextButton(true);
                return true;
            }
            setDisableNextButton(false);
            return false;
        }
        return false;
    }, [submissionVM?.uwIssues_ML?.value]);

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0) {
            const questionCheckpointIssues = issues.filter((issue) => {
                return issue.checkingSet_Ext === 'vehicle_exposure_ml' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            setDisableNextButton(questionCheckpointIssues?.length > 0);
        }
    }, []);

    const validateVehicles = useCallback(() => {
        pupModel.coverables.vehicles.children.forEach((vehicle) => {
            vehicle.value.error = !(vehicle.aspects.valid && vehicle.aspects.subtreeValid);
        });
        if (pupModel.coverables.vehicles.children.find((vehicle) => vehicle.value.error)) {
            return { ...messages.objectNeedAttention, args: { item: translator(messages.vehicleListTitle) } };
        }
    }, [pupModel.coverables.vehicles.children, translator]);

    const validateDrivers = useCallback(() => {
        pupModel.coverables.vehicleOperators.children.forEach((vehicleOperator) => {
            if (vehicleOperator.contact.gender.value != null
                && vehicleOperator.contact.maritalStatus.value != null
                && vehicleOperator.relationshipToInsured.value != null
                && !vehicleOperator.driverStatusForAdding.value) {
                vehicleOperator.driverStatusForAdding.value = 'insure_driver';
            }
            vehicleOperator.contact.isGenderRequired.value = true;
            vehicleOperator.isRelationshipRequired.value = true;
            vehicleOperator.isDriverStatusForAddingRequired.value = true;
            vehicleOperator.isDriverTypeRequired.value = true;

            if (vehicleOperator.driverType.value &&
                (vehicleOperator.driverType.value.code === 'rated')) {
                vehicleOperator.contact.isMaritalStatusRequired.value = true;
                vehicleOperator.isAgeFirstLicensedRequired.value = true;
            } else {
                vehicleOperator.contact.isMaritalStatusRequired.value = false;
                vehicleOperator.isAgeFirstLicensedRequired.value = false;
            }
            vehicleOperator.value.error = !(vehicleOperator.aspects.valid && vehicleOperator.aspects.subtreeValid);
        });
        const spouseOperators = pupModel.coverables.vehicleOperators.children.filter((vehicleOperator) => vehicleOperator.relationshipToInsured.value &&
            vehicleOperator.relationshipToInsured.value.code === 'spouse');

        if (spouseOperators.length > 1) {
            pupModel.coverables.vehicleOperators.children.forEach((vehicleOperator) => {
                if (vehicleOperator.relationshipToInsured.value && vehicleOperator.relationshipToInsured.value.code === 'spouse') {
                    vehicleOperator.value.error = true;
                }
            });
        }

        const errorAlerts = [];

        if (pupModel.coverables.vehicleOperators.children
            .filter((vehicleOperator) => vehicleOperator.driverType.value.code === 'rated')
            .find((vehicle) => vehicle.value.error)
        ) {
            errorAlerts.push({ ...messages.objectNeedAttention, args: { item: translator(messages.Drivers) } });
        }
        if (pupModel.coverables.vehicleOperators.children
            .filter((vehicleOperator) => vehicleOperator.driverType.value.code === 'excluded')
            .find((vehicle) => vehicle.value.error)
        ) {
            errorAlerts.push({ ...messages.objectNeedAttention, args: { item: translator(messages.ExcludedDrivers) } });
        }
        if (pupModel.coverables.vehicleOperators.children
            .filter((vehicleOperator) => isHouseholdMember(vehicleOperator.driverType.value?.code) || isNonDriver(vehicleOperator.driverType.value?.code))
            .find((vehicle) => vehicle.value.error)
        ) {
            errorAlerts.push({ ...messages.objectNeedAttention, args: { item: isModernProduct ? translator(messages.NonDrivers) : translator(messages.HouseholdMembers) } });
        }
        return errorAlerts;
    }, [isModernProduct, pupModel.coverables.vehicleOperators.children, translator]);

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Vehicle Exposure Page'});
            });
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
        checkForQuestionUwIssues();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);


    const validatePage = useCallback(() => {
        const ALERT_BLOCK_ITEM_NEED_ATTENTION = 'ALERT_BLOCK_ITEM_NEED_ATTENTION';
        const vehicleErrorAlert = validateVehicles();
        const driverErrorAlerts = validateDrivers();

        clearBlockAlerts(ALERT_BLOCK_ITEM_NEED_ATTENTION);
        if (vehicleErrorAlert || driverErrorAlerts.length > 0) {
            if (vehicleErrorAlert) {
                addErrorAlert(vehicleErrorAlert, ALERT_BLOCK_ITEM_NEED_ATTENTION);
            }
            driverErrorAlerts.forEach((error) => addErrorAlert(error, ALERT_BLOCK_ITEM_NEED_ATTENTION));
            refreshData();
        }
    }, [validateVehicles, validateDrivers, clearBlockAlerts, refreshData, addErrorAlert]);

    const handleULPolicyAlerts = useCallback((warningMissingExposureMessages) => {
        const ALERT_BLOCK_UL_POLICY = 'ALERT_BLOCK_UL_POLICY';
        clearBlockAlerts(ALERT_BLOCK_UL_POLICY);
        warningMissingExposureMessages.forEach((message) => addErrorAlert(message, ALERT_BLOCK_UL_POLICY));
    }, [addErrorAlert, clearBlockAlerts]);

    const validateULPolicy = useCallback(() => {
        const warningMissingExposureMessages = validateVehicleDriverDetailsExposures(pupModel);
        handleULPolicyAlerts(warningMissingExposureMessages);
    }, [handleULPolicyAlerts, pupModel, validateVehicleDriverDetailsExposures]);

    const setPrimaryNamedGender = useCallback(() => {
        if (isGPA) {
            pupModel.coverables.vehicleOperators.value.forEach((driver) => {
                if (driver.relationshipToInsured === 'self') {
                    if (driver.contact.gender) {
                        if (driver.contact.gender === 'F') {
                            submissionVM.baseData.primaryNamedInsured_ML.gender = 'F';
                        } else if (driver.contact.gender === 'x_ml') {
                            submissionVM.baseData.primaryNamedInsured_ML.gender = 'x_ml';
                        } else {
                            submissionVM.baseData.primaryNamedInsured_ML.gender = 'M';
                        }
                        refreshData();
                    }
                }
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const fixAddDriverMetadataOrder = useCallback(() => {
        const clonedMetadata = _.cloneDeep(originalAddDriverMetadata);

        const formContent = clonedMetadata.pageContent.content[0].content[2].content;

        const aux = formContent[1];
        formContent[1] = formContent[3];
        formContent[3] = aux;

        formContent.push(
            {
                id: 'maritalStatusRow',
                type: 'container',
                component: 'div',
                componentProps: {
                    className: 'row help-text-row vertical-spacing-40 col-md-12'
                },
                content: [
                    {
                        id: 'maritalStatusControl',
                        type: 'container',
                        component: 'div',
                        componentProps: {
                            className: 'col-md-4 remove-form-group-spacing'
                        },
                        content: [
                            {
                                id: 'maritalStatus',
                                type: 'field',
                                component: 'dropdownselect',
                                componentProps: {
                                    className: 'dobRow',
                                    format: 'vshort',
                                    label: {
                                        id: 'ml.platform.inputs.contact-details.Marital Status',
                                        defaultMessage: 'Marital Status'
                                    },
                                    labelPosition: 'top',
                                    path: 'contact.maritalStatus',
                                    alwaysShowPlaceholder: true,
                                    searchable: true
                                }
                            }
                        ]
                    },
                    {
                        id: 'maritalStatusTooltipContainer',
                        type: 'container',
                        component: 'div',
                        componentProps: {
                            className: 'col-md-6 tooltipContainerOverride'
                        },
                        content: [
                            {
                                id: 'maritalStatusHelp',
                                type: 'element',
                                component: 'MLTooltipComponent',
                                componentProps: {
                                    tooltipLabel: {
                                        id: 'ml.platform.inputs.helptext.What does this mean?',
                                        defaultMessage: 'What does this mean?'
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        );

        formContent.unshift(
            {
                id: 'error',
                type: 'element',
                component: 'InlineNotification',
                componentProps: {
                    isDismissable: false,
                    type: 'error',
                    message: 'Inline notification message',
                    messageProps: {
                        error: ' '
                    }
                }
            }
        );

        const changePaceForAgeFirstLicensed = formContent[5];
        formContent[5] = formContent[8];
        formContent[8] = formContent[6];
        formContent[6] = changePaceForAgeFirstLicensed;

        const spousePopoverRow = {
            id: 'spousePopoverContainer',
            type: 'container',
            component: 'div',
            componentProps: {
                className: 'row vertical-spacing-10 col-md-12 spouse-margin-top'
            },
            content: [
                {
                    id: 'spousePopoverColumn',
                    type: 'container',
                    component: 'div',
                    componentProps: {
                        className: 'col-md-4 remove-form-group-spacing'
                    },
                    content: [
                        {
                            id: 'spousePopoverComponent',
                            type: 'component',
                            component: 'spousepopovercomponent'
                        }
                    ]
                }
            ]
        };

        const existingSpousePopoverIndex = formContent.findIndex(
            (item) => item.id === 'spousePopoverContainer'
        );

        if (existingSpousePopoverIndex > -1) {
            formContent.splice(existingSpousePopoverIndex, 1);
        }

        const maritalStatusRowIndex = formContent.findIndex(
            (item) => item.id === 'maritalStatusRow'
        );

        if (maritalStatusRowIndex > -1) {
            formContent.splice(maritalStatusRowIndex + 1, 0, spousePopoverRow);
        }

        setAddDriverMetadata(clonedMetadata);
    }, []);  
    useEffect(() => {
        clearAlerts();
        fixAddDriverMetadataOrder();
        setPrimaryNamedGender();
        validatePage();

        if (returnToQuoteFlag) {
            const warningMissingExposureMessages = validateVehicleDriverDetailsExposures(pupModel);
            handleULPolicyAlerts(warningMissingExposureMessages);
            if (warningMissingExposureMessages.length > 0) {
                window.scrollTo(0, 0);
            }
        }

        refreshData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const _isPrimaryNamedInsured = (vehicleOperator) => {
        const index = pupModel.coverables.vehicleOperators.value.findIndex((operator) => operator.relationshipToInsured === 'self');
        const primaryNamedInsured = pupModel.coverables.vehicleOperators.getElement(index);
        return isSamePerson(vehicleOperator?.contact?.value, primaryNamedInsured?.contact?.value);
    };

    const _isSecondaryNamedInsured = (vehicleOperator) => {
        if (submissionVM.baseData.secondaryNamedInsured_ML.value) {
            return isSamePerson(vehicleOperator.contact.value, submissionVM.baseData.secondaryNamedInsured_ML.value);
        }
    };

    const _isExcludedReason = (removalReason) => {
        if (isModernProduct) {
            return ['license_revoked', 'unwanted', 'unabletodrive', 'registeredowner'].includes(removalReason);
        }
        return ['license_revoked', 'unwanted'].includes(removalReason);
    };

    const _isHouseholdNonDriverReason = (removalReason) => {
        if (isModernProduct) {
            return ['unknown', 'deceased', 'own_insurance', 'abroad', 'mission', 'permit'].includes(removalReason);
        }
        return ['own_insurance', 'never_licensed', 'abroad', 'mission', 'permit'].includes(removalReason);
    };

    const _checkDOB = (originalVehicleOperator, vehicleOperator) => {
        const driverType = originalVehicleOperator.driverType.value ? originalVehicleOperator.driverType.value : originalVehicleOperator.driverType;
        const driverTypeCode = driverType.code ? driverType.code : driverType;
        if (driverTypeCode) {
            switch (driverTypeCode) {
                case 'household':
                case 'nondriver':
                case 'permit':
                case 'outofhousehold':
                    if (vehicleOperator.contact.dateOfBirthForNonDriver.value) {
                        vehicleOperator.contact.dateOfBirth.value = vehicleOperator.contact.dateOfBirthForNonDriver.value;
                    }
                    break;
                default:
                    if (vehicleOperator.contact.dateOfBirth.value) {
                        vehicleOperator.contact.dateOfBirthForNonDriver.value = vehicleOperator.contact.dateOfBirth.value;
                    }
                    break;
            }
        }
    };

    const _setDriverType = (vehicleOperator, driverStatus, isAddOperation) => {
        let driverType = '';
        if (isAddOperation) {
            if (isUMB_NP) {
                driverType = getUmbrellaDriverTypeNewProduct(driverStatus);
            } else {
                switch (driverStatus) {
                    case 'insure_driver':
                    case 'discovered':
                        driverType = 'rated';
                        break;
                    case 'license_revoked':
                    case 'unwanted':
                        driverType = (canExcludeDrivers === false) ? 'rated' : 'excluded';
                        break;
                    case 'abroad':
                    case 'never_licensed':
                    case 'own_insurance':
                    case 'mission':
                    case 'permit':
                        driverType = 'household';
                        break;
                    case 'not_household':
                    case 'notresiding':
                    case 'duplicate_driver_ml':
                    case 'deceased':
                    case 'unknown':
                        driverType = (canExcludeDrivers === false) ? '' : 'excluded';
                        break;
                    default:
                        driverType = '';
                        break;
                }
            }
        } else {
            if (isUMB_NP) {
                switch (driverStatus) {
                    case 'insure_driver':
                    case 'discovered':
                        driverType = 'rated';
                        break;
                    case 'license_revoked':
                        driverType = 'excluded';
                        break;
                    case 'unwanted':
                        driverType = 'excluded';
                        break;
                    case 'abroad':
                        driverType = 'outofhousehold';
                        break;
                    case 'mission':
                        driverType = 'outofhousehold';
                        break;
                    case 'permit':
                        driverType = 'permitted';
                        break;
                    case 'notresiding':
                    case 'duplicate_driver_ml':
                    case 'not_household':
                        driverType = null;
                        break;
                    case 'own_insurance':
                    case 'deceased':
                        driverType = 'nondriver';
                        break;
                    case 'unknown':
                        driverType = 'nondriver';
                        break;
                    case 'unabletodrive':
                        driverType = 'excluded';
                        break;
                    case 'registeredowner':
                        driverType = 'excluded';
                        break;
                    default:
                        driverType = '';
                        break;
                }
            } else {
                switch (driverStatus) {
                    case 'insure_driver':
                    case 'discovered':
                        driverType = 'rated';
                        break;
                    case 'license_revoked':
                    case 'unwanted':
                        driverType = (canExcludeDrivers === false) ? 'rated' : 'excluded';
                        break;
                    case 'abroad':
                    case 'never_licensed':
                    case 'own_insurance':
                    case 'mission':
                    case 'permit':
                        driverType = 'household';
                        break;
                    case 'not_household':
                    case 'notresiding':
                    case 'duplicate_driver_ml':
                    case 'deceased':
                    case 'unknown':
                        driverType = (canExcludeDrivers === false) ? '' : 'excluded';
                        break;
                    default:
                        driverType = '';
                        break;
                }
            }
        }
        vehicleOperator.driverType.value = driverType;
    };

    const _setDriverTypeForNonExcludedStates = (vehicleOperator, driverStatus) => {
        let driverType = '';
        switch (driverStatus){
            case 'license_revoked':
                driverType = 'rated';
                break;
            case 'notresiding':
            case 'own_insurance':
            case 'never_licensed':
            case 'abroad':
            case 'mission':
            case 'permit':
                driverType = 'household';
                break;
        }
        vehicleOperator.driverType.value = driverType;
    }

    const getDriverStatusTypeOptions = (filter, driverType) => {
        const typelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');
        const codesForDriverType = getUmbrellaDriverNotListedReasonsForAdding(driverType, isModernProduct);
        let codes;
        switch (filter) {
            case 'remove':
                codes = typelist.codes.filter((reason) => {
                    return driverType === 'rated' ? ['insure_driver' , 'discovered','notresiding'].indexOf(reason.code) < 0 : true;
                });
                break;
            case 'add':
                codes = typelist.codes.filter((reason) => {
                    return codesForDriverType.includes(reason.code);
                });
                break;
            default:
                codes = typelist.codes;
        }
        return codes.map((option) => {
            return {
                code: option.code,
                name: translator({
                    id: option.name,
                    defaultMessage: option.name
                })
            };
        });
    };

    const getFormattedDateString = useCallback((gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }, [intl]);

    const getTableField = (item, index, property) => {
        const field = _.get(item, property.path);
        if (field && typeof field.value === 'object') {
            if (field.value && field.value.name && field.value.hasOwnProperty('typelist')) {
                return translator({ id: field.value.name });
            }
            return field.value;
        }
        if (field && field._dtoName === 'Boolean') {
            if (field.value === true) {
                return translator({ id: "ml.platform.inputs.Yes", defaultMessage: "Yes" });
            }
            if (field.value === false) {
                return translator({ id: "ml.platform.inputs.No", defaultMessage: "No" });
            }
            return undefined;
        }
        if (field) {
            return field.value;
        }
        return undefined;
    };

    const getFormattedDate = (item, index, property) => {
        const date = getTableField(item, index, property);
        if (date) {
            return getFormattedDateString(date);
        }
        return undefined;
    };

    const getVehicleNameField = (item, index, property) => {
        const field = getTableField(item, index, property);
        if (item.value.error) {
            return (
                <span className={styles.errorText}>
                    <strong>
                        <i className="icon-ml-alert-icon icon-red" />
                        {field}
                    </strong>
                </span>
            );
        }
        return <strong>{field}</strong>;
    };

    const getNameField = (item, index, property) => {
        const field = getTableField(item, index, property);
        if (item.value.error) {
            return (
                <span className={styles.errorText}>
                    <strong>
                        <i className="icon-ml-alert-icon icon-red" />
                        {field}
                    </strong>
                </span>
            );
        }
        return <span>{field}</span>;
    };

    const validateUnderlyingPAPolicies = () => {
        const validPolicyTypeCodes = [
            UL_POLICY_CODES.AUTO,
            UL_POLICY_CODES.RECREATIONAL_VEHICLE,
            UL_POLICY_CODES.MOTORCYCLE
        ];
       
        const ulPolicies = pupModel.underlyingPolicies.children.filter((ul) => validPolicyTypeCodes.some((policyType) => policyType === ul.value.policyType));
        
        return ulPolicies.length > 0;
    };

    const getActionField = (item, index, property) => {
        return (
            <div>
                {property.children.map((child) => {
                    return (
                        <div>
                            <Link disabled={disableRemoveBtnForPNIFlagInUMP_Ext && isPersonalUmbrella && property.id === "driverActions" && child.props.id === "remove" && item?.isPrimaryNamedInsured.value  && validateUnderlyingPAPolicies()} onClick={() => child.props.onClick(item, index)}>
                                {translator(child.props.label)}
                            </Link>
                        </div>
                    );
                })}
            </div>
        );
    };

    const getVehicleActionField = (item, index, property) => {
        return (
            <div>
                {property.children.map((child) => {
                    if (child.props.id === "remove" && item.fromPrefill_ML.value && !isUMB_NP) {
                    return (<React.Fragment />);
                    }
                    return (
                        <div>
                            <Link onClick={() => child.props.onClick(item, index)}>
                                {translator(child.props.label)}
                            </Link>
                        </div>
                    );
                })}
            </div>
        );
    };

    const onVehicleEdit = (vehicle) => {
        const vehicleVM = viewModelService.clone(vehicle);
        updateRecentlyAddedVehicle(vehicleVM);
        updateVehicleEditedOriginal(vehicle);
        setEditVehiclePopupOpen(true);
        setDisableNextButton(false);
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit Vehicle`);
    };

    const getUnderlyingPolicies = () => {
        let addedPolicy;
        if (isInSync === false) {
            if (pupModel.underlyingPolicies.value.findIndex((ulPolicy) => ulPolicy.ulPolicyFixID === 'new') === -1) {
                addedPolicy = pupModel.value.createUnderlyingPolicy({
                    ulPolicyFixID: 'new',
                    policyNumber: translator(messages.underlyingPolicyNotListed)
                });
            }
        }

        const mappedValues = pupModel.underlyingPolicies.children.map((policy) => {
            let underlyingPolicyDisplayName = policy.value.getDisplayName(viewModelService.productMetadata, translator);
            if(isUMB_NP && policy.policyType.value?.code === 'HO') {
                underlyingPolicyDisplayName = underlyingPolicyDisplayName.replace('Homeowners', 'Property');
            }
            return {
                code: policy.ulPolicyFixID.value,
                name: underlyingPolicyDisplayName
            };
        });

        if (addedPolicy !== undefined) {
            pupModel.value.removeUnderlyingPolicy(addedPolicy);
        }
        return mappedValues;
    };

    const checkForDuplicateVin = (vin, vehicle) => {
        if (vin === undefined) {
            return false;
        }
        let idx = -1;
        if (vehicle) {
            idx = pupModel.coverables.vehicles.children.indexOf(vehicle);
        }
        return pupModel.coverables.vehicles.children.find((veh, index) => veh.vin.value === vin && index !== idx);
    };

    const checkforNonOwnedPolicy = (ulPolicyFixID) => {
        if (ulPolicyFixID === undefined) {
            return false;
        }
        const policy = pupModel.underlyingPolicies.value.find((ulPolicy) => ulPolicy.ulPolicyFixID === ulPolicyFixID);
        return policy.namedNonOwner_Ext === true;
    };

    const cancelAddUnderlyingPolicy = (policy) => {
        pupModel.value.removeUnderlyingPolicy(policy);
        validatePage();
        if (clickedOnNext) {
            validateULPolicy();
        }
        refreshData();
    };

    const getAddPolicyPopupProps = (underlyingVM, isEdit = false) => {
        const componentProps = {
            title: messages.addAPolicy,
            viewModel: underlyingVM,
            uiProps: addEditUnderlyingPolicyPopupMetadata.pageContent,
            actionBtnLabel: commonMessages.mlContinue,
            getOverrideProps: () => {
                return {
                    underlyingPolicyComponent: {
                        underlyingPolicyVM: underlyingVM,
                        sessionUUID: submissionVM.value.sessionUUID,
                        quoteID: submissionVM.value.quoteID,
                        isEdit,
                        authHeader,
                        isComponent: true,
                        MLAlertService,
                        isModernProduct
                    }
                };
            },
            customComponentResolvers: {
                underlyingPolicyComponent: UnderlyingPolicyComponent,
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent,
                spousepopovercomponent: SpousePopoverComponent
            },
        };

        return componentProps;
    };

    const onAddPolicy = () => {
        const newUnderlyingPolicy = pupModel.value.createUnderlyingPolicy();
        const underlyingVM = submissionVM.lobData.personalUmbrella.underlyingPolicies.findFirstElement(newUnderlyingPolicy);
        let componentProps = getAddPolicyPopupProps(underlyingVM);
        componentProps = {
            ...componentProps,
            onSaveAction: () => {
                validatePage();
                if (clickedOnNext) {
                    validateULPolicy();
                }
                refreshData();
                return true;
            }
        };
        return modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).catch(() => cancelAddUnderlyingPolicy(underlyingVM.value));
    };

    const removeVinIfNotNeeded = (vehicle) => {
        const typesWithVin = ['private_passenger_autos_ml', 'vans_suvs_ml', 'pickups_ml', 'Motorcycle', 'collectible_ml', 'other'];
        if (!typesWithVin.includes(vehicle.value.type)) {
            vehicle.vIN = undefined;
        }
    };

    const onSaveVehicle = (newVehicleVM, originalVehicle) => {
        const policyEffDate = submissionVM.baseData.periodStartDate.value;
        const validationResult = validateVehicleAddition(newVehicleVM.value, pupModel.coverables.vehicles, policyEffDate);
        if (validationResult.hasError) {
            newVehicleVM.error.message = validationResult.errorMessage;
            return false;
        }
        readyVehicleForSave(newVehicleVM);
        removeVinIfNotNeeded(newVehicleVM);
        if (!originalVehicle) {
            clearSuccessAlerts();
            const item = `${newVehicleVM.value.year} ${_.capitalize(newVehicleVM.value.make)} ${_.capitalize(newVehicleVM.value.model)}`;
            addSuccessAlert({
                ...messages.objectHasBeenAdded, args: {
                    item
                }
            });
            pupModel.coverables.vehicles.pushElement(newVehicleVM);
        } else {
            const idx = pupModel.coverables.vehicles.children.indexOf(originalVehicle);
            pupModel.coverables.vehicles.setElement(idx, newVehicleVM.value);
        }
        validatePage();
        if (clickedOnNext) {
            validateULPolicy();
        }
        refreshData();
        updateWizardData(submissionVM);
        const op = originalVehicle ? 'Edit' : 'Add';
        MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_${op} Vehicle`);
        return true;
    };

    const getVehicleEditPopup = () => {
        const vehicleVM = recentlyAddedVehicle;
        vehicleVM.isSerialNumberRequired_ML = false;
        vehicleVM.editMode_ML = true;
        const componentProps = {
            viewModel: vehicleVM,
            viewModelService: viewModelService,
            onSaveAction: (newVM) => onSaveVehicle(newVM, vehicleEditedOriginal),
            quoteID: submissionVM.quoteID.value,
            submissionVM: submissionVM,
            isGateway: false,
            isEdit: true,
            isPUP: true,
            isGPA,
            isUMB_NP,
            getUnderlyingPolicies,
            checkForDuplicateVin: (vin) => checkForDuplicateVin(vin, vehicleEditedOriginal),
            checkforNonOwnedPolicy: (vehicle) => checkforNonOwnedPolicy(vehicle),
            onAddPolicy,
            isOpen: isEditVehiclePopupOpen,
            onReject: () => setEditVehiclePopupOpen(false),
            onResolve: () => setEditVehiclePopupOpen(false),
            showProgressDialog,
            hideProgressDialog,
            isCompRaterQuote: !!submissionVM.hvqQuoteID_ML.value
        };

        return <PUPAddVehiclePopupComponent {...componentProps} />;
    };

    const onVehicleRemove = (vehicle, index) => {
        const vehicleVM = viewModelService.clone(vehicle);
        clearSuccessAlerts();
        const item = `${vehicleVM.value.year} ${_.capitalize(vehicleVM.value.make)} ${_.capitalize(vehicleVM.value.model)}`;
        addSuccessAlert({
            ...messages.objectHasBeenRemoved, args: {
                item
            }
        }, null, () => {
            clearSuccessAlerts();
            pupModel.coverables.vehicles.pushElement(vehicleVM);
            validatePage();
            if (clickedOnNext) {
                validateULPolicy();
            }
            refreshData();
            updateWizardData(submissionVM);
        });
        _.pullAt(pupModel.coverables.vehicles.value, [index]);
        validatePage();
        if (clickedOnNext) {
            validateULPolicy();
        }
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Vehicle`);
        refreshData();
        updateWizardData(submissionVM);
        setDisableNextButton(false);
    };

    const getVehicleTitle = () => {
        if (isQnB) {
            return (
                <div className='section-header'>
                    {translator(messages.vehicleListTitle)}
                </div>
            );
        }
        return translator(messages.vehicleListTitle);
    };

    const getDriversTitle = () => {
        if (isQnB) {
            return (
                <div className='section-header'>
                    {translator(messages.Drivers)}
                </div>
            );
        }
        return translator(messages.Drivers);
    };

    const getExcludedDriverTitle = () => {
        return (
            <div>
                <div className='section-header'>
                    {translator(messages.ExcludedDrivers)}
                </div>
                {pupModel.coverables.vehicleOperators.children.filter((child) => child.driverType.value.code === 'excluded').length > 0 && canExcludeDrivers &&
                    <p className={styles.tableSubtitle}>
                        {translator(messages.ExcludedDriversSubtitle)}
                    </p>
                }
                <div className={styles.tableSubtitle}>
                    {false && // isAMP
                        <MLTooltipComponent
                            tooltipLabel={translator(messages.ExcludedDriversTooltipHeader)}
                            tooltipContent={translator(messages.ExcludedDriverTooltipContent)}
                        />
                    }
                </div>
            </div>
        );
    };

    const getHouseholdMemberTitle = () => {
        return (
            <div>
                <div className=' section-header'>
                    {isUMB_NP ? translator(messages.NonDrivers) : translator(messages.HouseholdMembers)}
                </div>
                {pupModel.coverables.vehicleOperators.children.filter((child) => isHouseholdMemberOrNonDriver(child.driverType.value?.code)).length === 0 &&
                    <p className={styles.tableSubtitle}>
                        {isUMB_NP ? translator(messages.NonDriversSubtitleEmptyList) : translator(messages.HouseholdMemberSubtitleEmptyList)}
                    </p>
                }
                {pupModel.coverables.vehicleOperators.children.filter((child) => isHouseholdMemberOrNonDriver(child.driverType.value?.code)).length > 0 &&
                    <p className={styles.tableSubtitle}>
                        {isUMB_NP  ? translator(messages.nonOwnerMemberSubtitle) : translator(messages.HouseholdMemberSubtitle)}
                    </p>
                }
                <div className={styles.tableSubtitle}>
                    {false && // isAMP
                        <MLTooltipComponent
                            tooltipLabel={translator(messages.HouseholdMemberTooltipHeader)}
                            tooltipContent={translator(messages.HouseholdMemberTooltipHeader)}
                        />
                    }
                </div>
            </div>
        );
    };


    const addVehicleModel = () => {
        const vehicleObj = {
            // licenseState: accountHolder.primaryAddress.state
        };
        const { _xCenter, _dtoName } = pupModel.coverables.vehicles;
        const vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);
        vehicleVM.isModernProduct = submissionVM.value.isModernProduct_Ext;
        vehicleVM.error = {
            message: null
        };
        vehicleVM.editMode_ML = true;
        if (isGPA) {
            vehicleVM.value.isAgentCreated = true;
        }
        vehicleVM.value.policyState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
        updateRecentlyAddedVehicle(vehicleVM);
        return vehicleVM;
    };

    const onAddVehicle = () => {
        addVehicleModel();
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Vehicle`);
        setVehiclePopupOpen(true);
        setDisableNextButton(false);
    };

    const getVehiclePopup = () => {
        const vehicleVM = recentlyAddedVehicle;
        vehicleVM.isSerialNumberRequired_ML = false;

        const componentProps = {
            viewModel: vehicleVM,
            viewModelService: viewModelService,
            onSaveAction: onSaveVehicle,
            quoteID: submissionVM.quoteID.value,
            submissionVM: submissionVM,
            isGateway: false,
            isEdit: false,
            getUnderlyingPolicies,
            checkForDuplicateVin: (vin) => checkForDuplicateVin(vin),
            checkforNonOwnedPolicy: (vehicle) => checkforNonOwnedPolicy(vehicle),
            onAddPolicy,
            isPUP: true,
            isGPA,
            isUMB_NP,
            isOpen: isVehiclePopupOpen,
            onReject: () => setVehiclePopupOpen(false),
            onResolve: () => setVehiclePopupOpen(false),
            showProgressDialog,
            hideProgressDialog,
            isCompRaterQuote: !!submissionVM.hvqQuoteID_ML.value
        };

        return <PUPAddVehiclePopupComponent {...componentProps} />;
    };

    const checkUniqueSelf = (drivers) => {
        const selfMatch = drivers.filter((driver) => { return driver.relationshipToInsured === 'self'; });
        return selfMatch.length <= 1;
    };

    const checkUniqueSpouse = (drivers) => {
        const spouseMatch = drivers.filter((driver) => { return driver.relationshipToInsured === 'spouse'; });
        return spouseMatch.length <= 1;
    };

    const getDriversAge = (vehicleOperator) => {
        const dob = MLLocalDateUtil.localDate2Date(vehicleOperator.value.contact.dateOfBirthForNonDriver);
        _.set(vehicleOperator, 'driverAge.value', MLLocalDateUtil.differenceInYears(new Date(), dob));
    };

    const onChangeDOB = (vehicleOperator) => {
        // _.set(vehicleOperator, path, value);
        const driverType = _.get(vehicleOperator, 'driverType.value.code');
        if (driverType) {
            switch (driverType) {
                case 'household':
                case 'nondriver':
                case 'permit':
                case 'outofhousehold':
                    if (vehicleOperator.value.contact.dateOfBirthForNonDriver) {
                        vehicleOperator.value.contact.dateOfBirth = vehicleOperator.value.contact.dateOfBirthForNonDriver;
                    }
                    break;
                default:
                    if (vehicleOperator.value.contact.dateOfBirth) {
                        vehicleOperator.value.contact.dateOfBirthForNonDriver = vehicleOperator.value.contact.dateOfBirth;
                    }
                    getDriversAge(vehicleOperator);
                    break;
            }
        }
    };

    const addNewDriverModel = (driverType) => {
        const driverObj = {
            driverType: driverType,
            error: {
                message: null
            },
            editMode_ML: true,
            contact: {
                isGenderRequired: true
            },
            isRelationshipRequired: true,
            isDriverStatusForAddingRequired: true,
            isDriverTypeRequired: true
        };
        switch (driverType) {
            case 'rated':
                driverObj.driverStatusForAdding = 'insure_driver';
                driverObj.contact.isMaritalStatusRequired = true;
                driverObj.contact.isDateOfBirthRequired = true;
                driverObj.isAgeFirstLicensedRequired = true;
                break;
            case 'excluded':
                driverObj.contact.isDateOfBirthRequired = true;
                driverObj.isAgeFirstLicensedRequired = false;
                break;
            default:
                driverObj.contact.isMaritalStatusRequired = false;
                driverObj.contact.isDateOfBirthForNonDriverRequired = true;
                driverObj.isAgeFirstLicensedRequired = false;
        }

        updateRecentlyAddedDriver(driverObj);

        const { _xCenter, _dtoName } = pupModel.coverables.vehicleOperators;
        const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);

        return driverVM;
    };

    const _checkDriverOnAdd = (originalVehicleOperator, vehicleOperator) => {
        const driverStatus = vehicleOperator.driverStatusForAdding;
        if (driverStatus && driverStatus.value) {
            _setDriverType(vehicleOperator, driverStatus.value.code,true);
        }
        _checkDOB(originalVehicleOperator, vehicleOperator);
    };


    const displayAddingAlerts = (originalVehicleOperator, currentVehicleOperator, driverStatusForRemovingCode) => {
        let alertMsg = '';
        let alertName = '';
        let alertHelpTitle = '';
        let alertHelpMessage = '';

        const previousDriverType = originalVehicleOperator.driverType ? originalVehicleOperator.driverType : undefined;
        const currentDriverType = currentVehicleOperator.driverType ? currentVehicleOperator.driverType.value.code : undefined;

        if (currentDriverType === 'rated' && previousDriverType !== 'rated') {
            alertMsg = {
                ...messages.objectHasBeenAdded, args: {
                    item: currentVehicleOperator.contact.displayName.value
                }
            };
            alertName = `driverAdded${currentVehicleOperator.value.contact.displayName}`;
        } else if (isHouseholdMemberOrNonDriver(currentDriverType) && !isHouseholdMemberOrNonDriver(previousDriverType)) {
            if(isUMB_NP) {
                alertMsg = {
                    ...messages.nonDriverHasBeenAdded, args: {
                        item: currentVehicleOperator.contact.displayName.value
                    }
                };
                alertName = `nonDriverHasBeenAdded${currentVehicleOperator.value.contact.displayName}`;
            } else {
                alertMsg = {
                    ...messages.hhMemberHasBeenAdded, args: {
                        item: currentVehicleOperator.contact.displayName.value
                    }
                };
                alertName = `householdMemberAdded${currentVehicleOperator.value.contact.displayName}`;
            }
        } else if (canExcludeDrivers && _isExcludedReason(driverStatusForRemovingCode)) {
            alertMsg = {
                ...messages.excludedHasBeenAdded, args: {
                    item: currentVehicleOperator.contact.displayName.value
                }
            };
            alertName = `excludedDriver${currentVehicleOperator.value.contact.displayName}`;
            alertHelpTitle = messages.driverMustBeRatedOrExcluded;
            alertHelpMessage = messages.driverMustBeRatedOrExcludedText;
        }

        if (alertName !== '' && previousDriverType !== currentDriverType) {
            if (!!alertHelpTitle && !!alertHelpMessage) {
                addSuccessAlert(alertMsg, alertName, null, alertHelpTitle, alertHelpMessage);
            } else {
                addSuccessAlert(alertMsg, alertName);
            }
        }
    };

    const onSaveDriver = (vehicleOperator, isEdit, originalVehicleOperator) => {
        clearErrorAlerts();
        const singularDriverTypeDisplayName = _getDriverTypeDisplayName(vehicleOperator.driverType.value.code, true);
        if (isEdit) {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit ${singularDriverTypeDisplayName}`);
        } else {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add ${singularDriverTypeDisplayName}`);
        }
        vehicleOperator.value.error = {
            message: null,
            secondaryNamedInsured: false
        };
        const driverList = [...pupModel.coverables.vehicleOperators.value];
        if (isEdit) {
            const idx = pupModel.coverables.vehicleOperators.children.indexOf(originalVehicleOperator);
            _.pullAt(driverList, [idx]);
        }
        driverList.push(vehicleOperator.value);
        if (!checkUniqueSpouse(driverList)) {
            vehicleOperator.value.error.message = translator(messages.spouseError);
            window.scrollTo(0, 0);
            return false;
        }

        if (isPersonalUmbrella && isMarriedOrCivilUnion(vehicleOperator) && !hasSpouseSelected(vehicleOperator)) {
            vehicleOperator.value.error.message = translator(
                messages.spouseRequiredForMarriedDriver || {
                    id: 'ml.quoteandbind.pup.driver.spouseRequiredForMarriedDriver',
                    defaultMessage: 'Please identify a spouse.'
                }
            );

            window.scrollTo(0, 0);
            return false;
        }

        if (_isExcludedReason(vehicleOperator.driverStatusForAdding.value?.code)) {
            if (_isPrimaryNamedInsured(vehicleOperator)) {
                vehicleOperator.value.error.message = translator(messages.primaryInsuredError);
                window.scrollTo(0, 0);
                return;
            }
            if (_isSecondaryNamedInsured(vehicleOperator)) {
                vehicleOperator.value.error.message = translator(messages.secondaryNamedInsuredError);
                vehicleOperator.value.error.secondaryNamedInsured = true;
                window.scrollTo(0, 0);
                return;
            }
        }

        const driverStatusForAddingCode = vehicleOperator.driverStatusForAdding.value.code;
        if (isEdit) {
            _checkDriverOnAdd(originalVehicleOperator, vehicleOperator);
        } else {
            _checkDriverOnAdd(vehicleOperator, vehicleOperator);
        }
        if (isQnB && isHouseholdMemberOrNonDriver(vehicleOperator.driverType.value?.code)) {
            vehicleOperator.contact.isMaritalStatusRequired.value = false;
            vehicleOperator.isAgeFirstLicensedRequired.value = false;
        }
        if (vehicleOperator.aspects.valid && vehicleOperator.aspects.subtreeValid) {
            vehicleOperator.contact.updated.value = true;
            vehicleOperator.contact.displayName.value = getFullName(vehicleOperator.contact.value);
            vehicleOperator.editMode_ML.value = false;

            clearSuccessAlerts();
            if (isEdit) {
                displayAddingAlerts(originalVehicleOperator, vehicleOperator, driverStatusForAddingCode);
            } else {
                displayAddingAlerts(vehicleOperator, vehicleOperator, driverStatusForAddingCode);
            }
            let alertName;
            if (isEdit) {
                if (isHouseholdMemberOrNonDriver(vehicleOperator.driverType.value?.code)) {
                    alertName = `householdMemberAdded${vehicleOperator.value.contact.displayName}`;
                } else if (vehicleOperator.driverType.value.code === 'rated') {
                    alertName = `driverAdded${vehicleOperator.value.contact.displayName}`;
                } else if (vehicleOperator.driverType.value.code === 'excluded') {
                    alertName = `excludedDriver${vehicleOperator.value.contact.displayName}`;
                }
                clearBlockAlerts(alertName);
            }

            vehicleOperator.value.error = false;

            if (isEdit) {
                const idx = pupModel.coverables.vehicleOperators.children.indexOf(originalVehicleOperator);
                pupModel.coverables.vehicleOperators.setElement(idx, vehicleOperator.value);
            } else {
                pupModel.coverables.vehicleOperators.pushElement(vehicleOperator);
            }
            validatePage();
            if (clickedOnNext) {
                validateULPolicy();
            }

            updateWizardData(submissionVM);
            refreshData();
            updateWizardData(submissionVM);
            setDisableNextButton(false);
            return true;
        }
    };
    const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');

    const getMaritalStatusCode = (vehicleOperatorVM) => {
        return (
            _.get(vehicleOperatorVM, 'contact.maritalStatus.value.code') ||
            _.get(vehicleOperatorVM, 'contact.maritalStatus.value') ||
            _.get(vehicleOperatorVM, 'value.contact.maritalStatus')
        );
    };

    const isMarriedOrCivilUnion = (vehicleOperatorVM) => {
        const maritalStatusCode = getMaritalStatusCode(vehicleOperatorVM);

        return ['M', 'married', 'civil_union', 'civilunion'].includes(maritalStatusCode);
    };

    const hasSpouseSelected = (vehicleOperatorVM) => {
        return !!(
            _.get(vehicleOperatorVM, 'spouseID_ML.value') ||
            _.get(vehicleOperatorVM, 'value.spouseID_ML')
        );
    };

    const handleSpouseModelChange = () => {
        refreshData();
        updateWizardData(submissionVM);
    };

    const openDriverModal = (driverVM, isEdit, originalDriver = undefined) => {
        const singularDriverTypeDisplayName = _getDriverTypeDisplayName(driverVM.driverType.value?.code, true);
        const driverListForSpouse = pupModel.coverables.vehicleOperators.value || [];
        if (isEdit) {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit ${singularDriverTypeDisplayName}`);
        } else {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add ${singularDriverTypeDisplayName}`);
        }
        let modalTitle = `${translator(messages.editDriver)}`;
        if (!isGPA && !isEdit) {
            modalTitle = `${translator(messages.addNewDriver)}`;
        } else if (isGPA && !isEdit) {
            modalTitle = `${_.capitalize(translator(messages.ADDDRIVER))}`;
        }
        let actionBtnLabel = commonMessages.mlContinue;
        if (isGPA && isEdit) {
            actionBtnLabel = messages.editDriver;
        } else if (isGPA && !isEdit) {
            actionBtnLabel = messages.ADDDRIVER;
        }

        filterAvailableUmbrellaInsuredCandidates(submissionVM, pupModel.coverables.vehicleOperators.value);

        let insuredCandidateSelected = false;
        const setInsuredCandidateSelected = (selected) => {
            insuredCandidateSelected = selected;
        };

        const uniqueSelf = () => {
            const driverList = [...pupModel.coverables.vehicleOperators.value, driverVM.value];
            if (isEdit) {
                const idx = pupModel.coverables.vehicleOperators.children.indexOf(originalDriver);
                _.pullAt(driverList, [idx]);
            }
            return pupModel.coverables.vehicleOperators.value && !checkUniqueSelf(driverList);
        };

        const componentProps = {
            title: modalTitle,
            uiProps: addDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: actionBtnLabel,
            cancelBtnLabel: isGPA ? commonMessages.mlCancel : undefined,
            modalBodyStyles: addDriverModalBodyStyles,
            editValidateOnOpen: isEdit,
            getOverrideProps: () => {
                const uniqueSpouse = () => {
                    const driverList = [...pupModel.coverables.vehicleOperators.value, driverVM.value];
                    if (isEdit) {
                        const idx = pupModel.coverables.vehicleOperators.children.indexOf(originalDriver);
                        _.pullAt(driverList, [idx]);
                    }
                    return pupModel.coverables.vehicleOperators.value && !checkUniqueSpouse(driverList);
                };

                const driverListForSpouse = [
                    ...pupModel.coverables.vehicleOperators.value
                ];

                const showSpouseField = isPersonalUmbrella && isMarriedOrCivilUnion(driverVM);

                return {
                    insuredCandidatesComponent: {
                        visible: !isEdit,
                        submissionVM,
                        vehicleOperatorVM: driverVM,
                        driverType: isEdit ? driverVM.driverType.value.code : getRatedDriverType(),
                        setInsuredCandidateSelected,
                        viewModelService
                    },
                    formFieldsContainer: {
                        visible: insuredCandidateSelected || isEdit
                    },
                    nameRow: {
                        className: styles.nameRow
                    },
                    nameDetailsComponent: {
                        personVM: driverVM.contact,
                        isComponent: true
                    },
                    checkUniqueSelf: {
                        visible: uniqueSelf()
                    },
                    checkUniqueSpouse: {
                        visible: uniqueSpouse()
                    },
                    relationship: {
                        path: "relationshipToInsured",
                        alwaysShowPlaceholder: true
                    },
                    dob: {
                        path: "contact.dateOfBirth",
                        onBlur: () => {
                            onChangeDOB(driverVM);
                        }
                    },
                    dobTooltipContainer: {
                        visible: !isGPA
                    },
                    genderRow: {
                        path: "contact.gender",
                        availableValues: getFilteredGender(nbGenderState)
                    },
                    error: {
                        visible: driverVM?.value?.error?.message != null,
                        message: driverVM?.value?.error?.message,
                        className: styles["alert-error"]
                    },
                    maritalStatus: {
                        tooltip: isGPA ? {
                            title: messages.maritalStatusTooltipTitleGPA,
                            text: messages.maritalStatusTooltipTextGPA
                        } : undefined
                    },
                    maritalStatusHelp: {
                        tooltipContent: messages.maritalStatusTooltip
                    },
                    maritalStatusTooltipContainer: {
                        visible: !isGPA
                    },
                    spousePopoverContainer: {
                        visible: showSpouseField
                    },
                    spousePopoverComponent: {
                        visible: showSpouseField,
                        submissionVM,
                        driverVM,
                        driverList: driverListForSpouse,
                        handleSpouseModelChange: () => {
                            refreshData();
                            updateWizardData(submissionVM);
                        },
                        updateModifiers: _.noop,
                        isPolicyChange: false,
                        isCompRaterSpouseFeature: false,
                        isPersonalUmbrella: true,
                        disableAddNewSpouse: true
                    },
                    ratedDriversAgeFirstLicensed: {
                        path: "ageFirstLicensed",
                        className: styles.ratedDriversAgeFirstLicensed,
                        visible: true
                    },
                    driverLicenseContainer: {
                        path: "license",
                        visible: isPersonalUmbrella
                    },
                    stateContainer: {
                        path: "licenseState",
                        visible: isPersonalUmbrella
                    }
                };
            },
            disableButton: () => {
                return uniqueSelf(); // return false if duplicates are found
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent,
                spousepopovercomponent: SpousePopoverComponent
            },
            onSaveAction: (vehicleOperator) => onSaveDriver(vehicleOperator, isEdit, originalDriver)
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const onAddDriver = () => {
        const driverVM = addNewDriverModel('rated');
        openDriverModal(driverVM, false);
    };

    const openHouseholdMemberModal = (driverVM, isEdit, originalDriver = undefined) => {
        let modalTitle = `${translator(messages.editHHMember)}`;
        if (!isEdit) {
            modalTitle = `${_.capitalize(translator(messages.addHHMember))}`;
        }
        if (isUMB_NP) {
            modalTitle = isEdit ? `${_.capitalize(translator(messages.editNonDriver))}` : `${_.capitalize(translator(messages.addNonDriver))}`
        }
        let actionBtnLabel = commonMessages.mlContinue;
        if (isGPA && isEdit) {
            actionBtnLabel = messages.editHHMember;
        } else if (isGPA && !isEdit) {
            actionBtnLabel = messages.addHHMember;
        }
        if (isUMB_NP) {
            if (isEdit) {
                actionBtnLabel = messages.editNonDriver;
            } else if (!isEdit) {
                actionBtnLabel = messages.addNonDriver;
            }
        }

        filterAvailableUmbrellaInsuredCandidates(submissionVM, pupModel.coverables.vehicleOperators.value);

        let insuredCandidateSelected = false;
        const setInsuredCandidateSelected = (selected) => {
            insuredCandidateSelected = selected;
        };

        const uniqueSelf = () => {
            const driverList = [...pupModel.coverables.vehicleOperators.value, driverVM.value];
            if (isEdit) {
                const idx = pupModel.coverables.vehicleOperators.children.indexOf(originalDriver);
                _.pullAt(driverList, [idx]);
            }
            return pupModel.coverables.vehicleOperators.value && !checkUniqueSelf(driverList);
        };

        const householdDriverType = isModernProduct ? 'nondriver' : 'household';

        const componentProps = {
            title: modalTitle,
            uiProps: AddHouseholdMemberPopup.metadata.pageContent,
            viewModel: driverVM,
            viewModelService: viewModelService,
            actionBtnLabel: actionBtnLabel,
            cancelBtnLabel: isGPA ? commonMessages.mlCancel : undefined,
            modalBodyStyles: AddHouseholdMemberPopup.styles,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: {
                        visible: !isEdit,
                        submissionVM,
                        vehicleOperatorVM: driverVM,
                        driverType: isEdit ? driverVM.driverType.value.code : householdDriverType,
                        setInsuredCandidateSelected,
                        viewModelService
                    },
                    formFieldsContainer: {
                        visible: insuredCandidateSelected || isEdit
                    },
                    nameRow: {
                        className: styles.nameRow
                    },
                    nameDetailsComponent: {
                        layout: 'ML-Name-Default',
                        personVM: driverVM.contact,
                        // to identify as a Component for FormModalPopover to attach onValidate function
                        isComponent: true
                    },
                    checkUniqueSelf: {
                        visible: uniqueSelf()
                    },
                    relationship: {
                        path: "relationshipToInsured",
                        alwaysShowPlaceholder: true
                    },
                    reason: {
                        label: translator(messages.reasonNotListedAsDriver),
                        path: "driverStatusForAdding",
                        availableValues: getDriverStatusTypeOptions('add', 'household')
                    },
                    dob: {
                        path: "contact.dateOfBirthForNonDriver",
                        onBlur: () => {
                            onChangeDOB(driverVM);
                        }
                    },
                    genderRow: {
                        path: "contact.gender",
                        availableValues: getFilteredGender(nbGenderState)
                    },
                    maritalStatusRow: {
                        visible: isGPA
                    },
                    maritalStatus: {
                        path: "contact.maritalStatus",
                        tooltip: isGPA ? {
                            title: messages.maritalStatusTooltipTitleGPA,
                            text: messages.maritalStatusTooltipTextGPA
                        } : undefined
                    },
                    errorNotification: {
                        visible: driverVM?.value?.error?.message != null
                    },
                    validationErrorMessage: {
                        content: driverVM?.value?.error?.message
                    },
                    secondaryNamedInsuredTooltipDiv: {
                        visible: !!driverVM.value.error?.secondaryNamedInsured && !isGPA
                    }
                };
            },
            disableButton: () => {
                return uniqueSelf(); // return false if duplicates are found
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent
            },
            onSaveAction: (vehicleOperator) => onSaveDriver(vehicleOperator, isEdit, originalDriver)
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const openExcludedDriverModal = (driverVM, isEdit, originalDriver = undefined) => {
        let modalTitle = `${translator(messages.editExcludedDriver)}`;
        if (!isEdit) {
            modalTitle = `${_.capitalize(translator(messages.addExcludedDriver))}`;
        }

        let actionBtnLabel = commonMessages.mlContinue;
        if (isGPA && isEdit) {
            actionBtnLabel = messages.editExcludedDriver;
        } else if (isGPA && !isEdit) {
            actionBtnLabel = messages.addExcludedDriver;
        }

        filterAvailableUmbrellaInsuredCandidates(submissionVM, pupModel.coverables.vehicleOperators.value);

        let insuredCandidateSelected = false;
        const setInsuredCandidateSelected = (selected) => {
            insuredCandidateSelected = selected;
        };

        const uniqueSelf = () => {
            const driverList = [...pupModel.coverables.vehicleOperators.value, driverVM.value];
            if (isEdit) {
                const idx = pupModel.coverables.vehicleOperators.children.indexOf(originalDriver);
                _.pullAt(driverList, [idx]);
            }
            return pupModel.coverables.vehicleOperators.value && !checkUniqueSelf(driverList);
        };

        const componentProps = {
            title: modalTitle,
            uiProps: AddExcludedDriverPopup.metadata.pageContent,
            viewModel: driverVM,
            viewModelService: viewModelService,
            actionBtnLabel: actionBtnLabel,
            cancelBtnLabel: isGPA ? commonMessages.mlCancel : undefined,
            modalBodyStyles: AddExcludedDriverPopup.styles,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: {
                        visible: !isEdit,
                        submissionVM,
                        vehicleOperatorVM: driverVM,
                        driverType: isEdit ? driverVM.driverType.value.code : getExcludedDriverType(),
                        setInsuredCandidateSelected,
                        viewModelService
                    },
                    formFieldsContainer: {
                        visible: insuredCandidateSelected || isEdit
                    },
                    nameDetailsComponent: {
                        layout: 'ML-Name-Default',
                        personVM: driverVM.contact,
                        // to identify as a Component for FormModalPopover to attach onValidate function
                        isComponent: true
                    },
                    checkUniqueSelf: {
                        visible: uniqueSelf()
                    },
                    relationship: {
                        path: "relationshipToInsured",
                        alwaysShowPlaceholder: true
                    },
                    reason: {
                        label: translator(messages.reasonNotListedAsDriver),
                        path: "driverStatusForAdding",
                        availableValues: getDriverStatusTypeOptions('add', 'excluded')
                    },
                    dob: {
                        path: "contact.dateOfBirth",
                        onBlur: () => {
                            onChangeDOB(driverVM);
                        }
                    },
                    dobTooltipComponent: {
                        tooltipContent: messages.dobTooltip
                    },
                    dobTooltipContainer: {
                        visible: !isGPA
                    },
                    genderRow: {
                        path: "contact.gender",
                        availableValues: getFilteredGender(nbGenderState)
                    },
                    maritalRow: {
                        visible: false
                    },
                    marital: {
                        visible: false
                    },
                    errorNotification: {
                        visible: driverVM?.value?.error?.message != null
                    },
                    validationErrorMessageIcon: {
                        className: driverVM.value.error?.secondaryNamedInsured && !isGPA ? "icon-ml-alert-icon" : "icon-ml-alert-icon vertical-spacing-0"
                    },
                    validationErrorMessage: {
                        content: driverVM.value.error?.message
                    },
                    secondaryNamedInsuredTooltipDiv: {
                        visible: !!driverVM.value.error?.secondaryNamedInsured && !isGPA
                    }
                };
            },
            disableButton: () => {
                return uniqueSelf(); // return false if duplicates are found
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent
            },
            onSaveAction: (vehicleOperator) => onSaveDriver(vehicleOperator, isEdit, originalDriver)
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const isStateND = () => submissionVM.baseData.policyAddress.state.value.code === 'ND';
    const isStateMD = () => submissionVM.baseData.policyAddress.state.value.code === 'MD';
    const isStateCO = () => submissionVM.baseData.policyAddress.state.value.code === 'CO';

    const validateRemovalReason = (driverVM) => {
        let alertToReturn;
        if (driverVM.value && canExcludeDrivers) {
            const removalReason = driverVM.value.driverStatusForRemoving;
            const isSpouse = driverVM.relationshipToInsured.value.code === 'spouse';
            const isNamedInsured = driverVM.relationshipToInsured.value.code === 'self';
            if (!canExcludeDrivers && _isExcludedReason(removalReason)) {
                alertToReturn = translator(messages.notValidReasonToRemoveDriver);
            } else if (isSpouse && !isUMB_NP && !isStateCO() && ((!(isStateND() || isStateMD()) && (removalReason !== 'never_licensed')) || ((isStateND() || isStateMD()) && removalReason !== 'license_revoked' && removalReason !== 'unwanted' && removalReason !== 'never_licensed'))) {
                alertToReturn = translator(messages.spouseCannotBeRemovedIfLicensed);
            } else if (!isStateND() && _isExcludedReason(removalReason) && isNamedInsured) {
                alertToReturn = translator(messages.notValidReasonToRemoveNamedInsured);
            } else if ((!isStateND() && !isStateMD() && !isStateCO()) && _isExcludedReason(removalReason) && _isSecondaryNamedInsured(driverVM)) {
                alertToReturn = translator(messages.notValidReasonToRemoveSecondaryNamedInsured);
            } else if (driverVM.driverType.value?.code === 'household') {
                if(!isUMB_NP) {
                    if (removalReason === 'own_insurance'
                                        || removalReason === 'never_licensed'
                                        || removalReason === 'abroad'
                                        || removalReason === 'mission'
                                        || removalReason === 'permit') {
                                        alertToReturn = translator(messages.notValidReasonToRemoveHouseholdMember);
                                    }
                } else {
                    if (removalReason === 'unknown'
                        || removalReason === 'deceased'
                        || removalReason === 'own_insurance'
                        || removalReason === 'abroad'
                        || removalReason === 'mission'
                        || removalReason === 'permit') {
                        alertToReturn = translator(messages.notValidReasonToRemoveHouseholdMember);
                    }
                }
            } else if (isSpouse && isUMB_NP && (removalReason !== 'never_licensed' && removalReason !== 'abroad')) {
                alertToReturn = translator(messages.spouseCannotBeRemovedIfLicensed);
            }
        }
        return alertToReturn;
    };

    let removedVehicleOperator;
    let initialDriversStatus;

    const _checkDriverOnRemove = (originalVehicleOperator, vehicleOperator) => {
        initialDriversStatus = originalVehicleOperator.driverStatusForAdding.value;
        const driverStatus = vehicleOperator.driverStatusForRemoving;
        if (driverStatus && driverStatus.value) {
            vehicleOperator.driverStatusForAdding.value = driverStatus.value.code;
            if(!canExcludeDrivers){
                _setDriverTypeForNonExcludedStates(vehicleOperator, driverStatus.value.code);
            }
            else{
                _setDriverType(vehicleOperator, driverStatus.value.code);
            }
        }
        _checkDOB(originalVehicleOperator, vehicleOperator);
        removedVehicleOperator = vehicleOperator.value;
    };

    const undoVehicleOperatorRemoval = () => {
        if (!isUMB_NP && (removedVehicleOperator.driverStatusForRemoving === 'not_household' || removedVehicleOperator.driverStatusForRemoving === 'duplicate_driver_ml' || removedVehicleOperator.driverStatusForRemoving === 'unknown' || removedVehicleOperator.driverStatusForRemoving === 'deceased'
            || removedVehicleOperator.driverStatusForRemoving === 'notresiding') || removedVehicleOperator.driverStatusForRemoving === 'duplicate_driver_ml' || removedVehicleOperator.driverStatusForRemoving === 'not_household' || removedVehicleOperator.driverStatusForRemoving === 'notresiding'
        ) {
            pupModel.coverables.vehicleOperators.value.push(removedVehicleOperator);
        } else {
            const indexDriverToUndo = pupModel.coverables.vehicleOperators.value.findIndex((operator) => operator.publicID === removedVehicleOperator.publicID);
            const driverToUndo = pupModel.coverables.vehicleOperators.getElement(indexDriverToUndo);
            driverToUndo.driverStatusForRemoving = undefined;
            driverToUndo.driverStatusForAdding.value = initialDriversStatus;
            _setDriverType(driverToUndo, driverToUndo.driverStatusForAdding.value.code,true);
        }
        updateWizardData(submissionVM);
        clearAlerts();
        removedVehicleOperator = {};
        validatePage();
        if (clickedOnNext) {
            validateULPolicy();
        }
        refreshData();
    };

    const _displayRemovingAlerts = (originalVehicleOperator, currentVehicleOperator, driverStatusForRemovingCode) => {
        let alertMsg;
        let alertType;
        let alertHelpTitle = '';
        let alertHelpMessage = '';

        const previousDriverType = _.get(originalVehicleOperator, 'driverType.value.code');
        const currentDriverType = _.get(currentVehicleOperator, 'driverType.value.code');

        // Driver was prevented from excluding
        if (previousDriverType === 'rated' && currentDriverType === 'rated') {
            if (_isExcludedReason(driverStatusForRemovingCode)) {
                addWarningAlert(messages.notValidReasonToRemoveDriver);
            }
        }

        // If the driver/household member/excluded driver is being removed properly, currentVehicleOperator will no longer have the value of the driverType and full name
        if (previousDriverType === 'rated' && currentDriverType !== 'rated') {
            if (isQnB) {
                if (currentDriverType === 'household') {
                    alertMsg = { ...messages.hhMemberHasBeenAdded, args: { item: originalVehicleOperator.value.contact.displayName } };
                } else if (currentDriverType === 'excluded' && (currentVehicleOperator.driverStatusForRemoving.value.code !== 'not_household' || currentVehicleOperator.driverStatusForRemoving.value.code !== 'duplicate_driver_ml' || currentVehicleOperator.driverStatusForRemoving.value.code !== 'unknown' || currentVehicleOperator.driverStatusForRemoving.value.code !== 'deceased')) {
                    alertMsg = { ...messages.excludedHasBeenAdded, args: { item: originalVehicleOperator.value.contact.displayName } };
                    alertHelpTitle = messages.driverMustBeRatedOrExcluded;
                    alertHelpMessage = messages.driverMustBeRatedOrExcludedText;
                }
            }  if (isUMB_NP) {
                if (isHouseholdMemberOrNonDriver(currentDriverType)) {
                    alertMsg = { ...messages.nonDriverHasBeenAddedWithUndo, args: { item: originalVehicleOperator.value.contact.displayName } };
                } else if (isExcludedDriver(currentDriverType) && _isExcludedReason(currentVehicleOperator.driverStatusForRemoving.value.code)) {
                    alertMsg = { ...messages.excludedHasBeenAdded, args: { item: originalVehicleOperator.value.contact.displayName } };
                    alertHelpTitle = messages.driverMustBeRatedOrExcluded;
                    alertHelpMessage = messages.driverMustBeRatedOrExcludedText;
                } else {
                    alertMsg = { ...messages.objectHasBeenRemoved, args: { item: originalVehicleOperator.value.contact.displayName } };
                }
            } else {
                alertMsg = { ...messages.objectHasBeenRemoved, args: { item: originalVehicleOperator.value.contact.displayName } };
            }
        } else if ((previousDriverType === 'household' && currentDriverType !== 'household') || (['nondriver',  'outofhousehold', 'permitted'].includes(previousDriverType) && currentDriverType === 'excluded')) {
            if (isUMB_NP && currentVehicleOperator.driverStatusForRemoving.value.code !== 'unknown' && currentVehicleOperator.driverStatusForRemoving.value.code !== 'deceased') {
                alertMsg = { ...messages.excludedHasBeenAdded, args: { item: originalVehicleOperator.value.contact.displayName } };
                alertHelpTitle = messages.driverMustBeRatedOrExcluded;
                alertHelpMessage = messages.driverMustBeRatedOrExcludedText;
            } else if(!isUMB_NP) {
                alertMsg = canExcludeDrivers || currentVehicleOperator.driverStatusForRemoving.value.code === 'not_household' || currentVehicleOperator.driverStatusForRemoving.value.code === 'duplicate_driver_ml' || currentVehicleOperator.driverStatusForRemoving.value.code === 'unknown' || currentVehicleOperator.driverStatusForRemoving.value.code === 'deceased' ?
                    { ...messages.householdMemberRemovedNoUndo, args: { item: originalVehicleOperator.value.contact.displayName } } :
                    messages.notValidReasonToRemoveHouseholdMemberRequiredListed;
                alertType = canExcludeDrivers ? 'success' : 'warning';
            } else{
                alertMsg = { ...messages.cantremovenonDriver, args: { item: originalVehicleOperator.value.contact.displayName } }
            }
        }else if(isUMB_NP && (driverStatusForRemovingCode === 'duplicate_driver_ml' || driverStatusForRemovingCode === 'not_household' || driverStatusForRemovingCode === 'notresiding')) {
               alertMsg = { ...messages.objectHasBeenRemoved, args: { item: originalVehicleOperator.value.contact.displayName } }; 
        } 
        else if (previousDriverType === 'excluded' && currentDriverType !== 'excluded') {
                alertMsg = { ...messages.excludedMemberRemovedNoUndo, args: { item: originalVehicleOperator.value.contact.displayName } };
        }

        if (_isExcludedReason(originalVehicleOperator.value.driverStatusForRemoving) && !!alertHelpTitle && !!alertHelpMessage) {
            addSuccessAlert(alertMsg, null, null, alertHelpTitle, alertHelpMessage);
        } else if ((originalVehicleOperator.value.driverStatusForRemoving === 'not_household' || originalVehicleOperator.value.driverStatusForRemoving === 'duplicate_driver_ml' || originalVehicleOperator.value.driverStatusForRemoving === 'unknown' || originalVehicleOperator.value.driverStatusForRemoving === 'deceased') && previousDriverType !== 'rated' && previousDriverType !== 'household' && previousDriverType !== 'nondriver' && currentDriverType === 'excluded') {
            alertMsg = { ...messages.excludedMemberRemoved, args: { item: originalVehicleOperator.value.contact.displayName } };
            addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval);
        } else if ((currentVehicleOperator.driverStatusForRemoving.value.code === 'not_household' || currentVehicleOperator.driverStatusForRemoving.value.code === 'duplicate_driver_ml' || currentVehicleOperator.driverStatusForRemoving.value.code === 'unknown' || currentVehicleOperator.driverStatusForRemoving.value.code === 'deceased'
            || currentVehicleOperator.driverStatusForRemoving.value.code === 'notresiding'
        ) && (previousDriverType === 'rated' && (currentDriverType === 'excluded' || currentDriverType === undefined))) {
            alertMsg = { ...messages.objectHasBeenRemoved, args: { item: originalVehicleOperator.value.contact.displayName } };
            addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval);
        } else if (_isHouseholdNonDriverReason(driverStatusForRemovingCode)) {
            if(!isUMB_NP){
                alertMsg = { ...messages.hhMemberHasBeenAddedWithUndo, args: { item: originalVehicleOperator.value.contact.displayName } };
                addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval);
            } else {
                alertMsg = { ...messages.notValidReasonToRemoveNonDriver};
                if (!isNonDriver(previousDriverType) && isNonDriver(currentDriverType)) {
                    alertMsg = { ...messages.nonDriverHasBeenAdded, args: { item: originalVehicleOperator.value.contact.displayName } };
                }
                addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval);
            }
        } else if (canExcludeDrivers && (_isExcludedReason(originalVehicleOperator.value.driverStatusForRemoving) || _isExcludedReason(originalVehicleOperator.value.driverStatusForAdding))) {
            if(!isUMB_NP) {
                    alertMsg = { ...messages.excludedHasBeenAdded, args: { item: originalVehicleOperator.value.contact.displayName } };
                    alertHelpTitle = messages.driverMustBeRatedOrExcluded;
                    alertHelpMessage = messages.driverMustBeRatedOrExcludedText;
                    addSuccessAlert(alertMsg, null, null, alertHelpTitle, alertHelpMessage);
            } else if (_isExcludedReason(originalVehicleOperator.value.driverStatusForRemoving) || (previousDriverType === 'excluded' && currentDriverType === 'excluded')) {
                alertMsg = {...messages.notValidReasonToRemoveExcludedMember};
                addSuccessAlert(alertMsg, null, null);
            } else{
                if(isUMB_NP && (driverStatusForRemovingCode === 'duplicate_driver_ml' || driverStatusForRemovingCode === 'not_household' || driverStatusForRemovingCode === 'notresiding')) {
                    alertMsg = { ...messages.objectHasBeenRemoved, args: { item: originalVehicleOperator.value.contact.displayName } }; 
                    addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval);
                }
            }
        } else if (_isExcludedReason(currentVehicleOperator.value.driverStatusForRemoving)) {
            addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval, alertHelpTitle, alertHelpMessage);
        } else {
            alertType = alertType || 'success';
            switch (alertType) {
                case 'success':
                    isUMB_NP ? addSuccessAlert(alertMsg, null, undoVehicleOperatorRemoval) : addSuccessAlert(alertMsg);
                    break;
                case 'warning':
                    addWarningAlert(alertMsg);
                    break;
                default:
                    break;
            }
        }
    };

    const onRemoveDriver = (vehicleOperator, originalVehicleOperator) => {
        _.set(vehicleOperator, 'contact.isGenderRequired.value', false);
        _.set(vehicleOperator, 'contact.isMaritalStatusRequired.value', false);
        _.set(vehicleOperator, 'isAgeFirstLicensedRequired', false);
        const wizardSnapShotData = viewModelService.clone(submissionVM);
        const singularDriverTypeDisplayName = _getDriverTypeDisplayName(vehicleOperator.driverType.value.code, true);
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove ${singularDriverTypeDisplayName}`);
        const driverStatusForRemovingCode = _.get(vehicleOperator, 'driverStatusForRemoving.value.code');
        const excludedReasonBool = _isExcludedReason(driverStatusForRemovingCode);
        const validation = validateRemovalReason(vehicleOperator);
        if (validation) {
            return false;
        }

        if (isStateMD() || isStateND()) {
            if (!driverStatusForRemovingCode
                || vehicleOperator.value.driverType === 'rated'
                && ((vehicleOperator.value.relationshipToInsured === 'spouse' && (driverStatusForRemovingCode !== 'never_licensed' && excludedReasonBool)) ||
                    ((_isPrimaryNamedInsured(vehicleOperator) || _isSecondaryNamedInsured(vehicleOperator) || !canExcludeDrivers) && excludedReasonBool))) {
                vehicleOperator.value.error = !(vehicleOperator.aspects.valid && vehicleOperator.aspects.subtreeValid);
            }
        } else if (!driverStatusForRemovingCode
            || vehicleOperator.value.driverType === 'rated'
            && ((vehicleOperator.value.relationshipToInsured === 'spouse' && (driverStatusForRemovingCode !== 'never_licensed')) ||
                ((_isPrimaryNamedInsured(vehicleOperator) || _isSecondaryNamedInsured(vehicleOperator) || !canExcludeDrivers) && excludedReasonBool))) {
            vehicleOperator.value.error = !(vehicleOperator.aspects.valid && vehicleOperator.aspects.subtreeValid);
        }

        _checkDriverOnRemove(originalVehicleOperator, vehicleOperator);
        clearAlerts();

        const vehicleOperatorSnapShotData = viewModelService.clone(vehicleOperator);

        if (driverStatusForRemovingCode === 'not_household' || driverStatusForRemovingCode === 'duplicate_driver_ml' || driverStatusForRemovingCode === 'unknown' || driverStatusForRemovingCode === 'deceased'
            || driverStatusForRemovingCode === 'notresiding'
        ) {
            removedVehicleOperator = originalVehicleOperator.value;
            removedVehicleOperator.driverStatusForRemoving = driverStatusForRemovingCode;

            const index = pupModel.coverables.vehicleOperators.value.findIndex((vo) => vo === vehicleOperator.value);
            addRemovedVehicleOperatorToAvailableCandidates(submissionVM, vehicleOperator.value);
            if(!isUMB_NP || driverStatusForRemovingCode === 'duplicate_driver_ml' || driverStatusForRemovingCode === 'not_household' || driverStatusForRemovingCode === 'notresiding'){
                pupModel.coverables.vehicleOperators.value.splice(index, 1);
            }
            validatePage();
            if (clickedOnNext) {
                validateULPolicy();
            }
            refreshData();
        }
        const newSubmissionVM = viewModelService.clone(submissionVM);
        const promise = LoadSaveService.updateDraftSubmission(newSubmissionVM.value, authHeader);
        showProgressDialog(commonMessages.saveSubmission, promise);
        promise.then((res) => {

            _displayRemovingAlerts(originalVehicleOperator, vehicleOperatorSnapShotData, driverStatusForRemovingCode);
            _.set(newSubmissionVM, 'value', res);
            clearExceptionErrors();
            updateWizardData(newSubmissionVM);
        }).catch((e)=>{
            updateWizardData(wizardSnapShotData);
            handleExceptionErrors(e);

        })
        setDisableNextButton(false);
        return true;
    };

    const onRemoveDriverCannotExclude = (vehicleOperator, originalVehicleOperator) => {
        const singularDriverTypeDisplayName = _getDriverTypeDisplayName(vehicleOperator.driverType.value.code, true);
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove ${singularDriverTypeDisplayName}`);
        const driverStatusForRemovingCode = _.get(vehicleOperator, 'driverStatusForRemoving.value.code');
        _checkDriverOnRemove(originalVehicleOperator, vehicleOperator);
        clearAlerts();
        _displayRemovingAlerts(originalVehicleOperator, vehicleOperator, driverStatusForRemovingCode);
        validatePage();
        if (clickedOnNext) {
            validateULPolicy();
        }
        refreshData();
        let areDriversValid = validateDrivers();
        if(areDriversValid.length === 0){
            const newSubmissionVM = viewModelService.clone(submissionVM);
            const promise = LoadSaveService.updateDraftSubmission(
                newSubmissionVM.value,
                authHeader
            );
            showProgressDialog(commonMessages.saveSubmission, promise);
            promise.then((res) => {
                _.set(newSubmissionVM, "value", res);
                updateWizardData(newSubmissionVM);
            });
        }
        setDisableNextButton(false);
        return true;
    }

    const openRemoveDriverModal = (driverVM, originalDriver) => {
        const driverName = _.startCase(_.get(driverVM, 'contact.displayName.value').trim().toLowerCase());
        const driverType = _.get(driverVM, 'driverType.value.code');
        let removeDriverModalTitle;
        switch (driverType) {
            case 'rated':
                removeDriverModalTitle = `${_.capitalize(translator(messages.removeDriver))} - ${driverName}`;
                break;
            case 'household':
            case 'nondriver':
            case 'permitted':
            case 'outofhousehold':
                removeDriverModalTitle = isUMB_NP ? `${_.capitalize(translator(messages.removeNonDriver))} - ${driverName}` : `${_.capitalize(translator(messages.removeHHMember))} - ${driverName}`;
                break;
            case 'excluded':
                removeDriverModalTitle = `${_.capitalize(translator(messages.removeExcludedDriver))} - ${driverName}`;
                break;
            default:
                removeDriverModalTitle = "";
        }

        let actionBtnLabel = commonMessages.mlContinue;
        if (isGPA) {
            switch (driverType) {
                case 'rated':
                    actionBtnLabel = messages.removeDriver;
                    break;
                case 'household':
                case 'nondriver':
                case 'permitted':
                case 'outofhousehold':
                    actionBtnLabel = isUMB_NP ? messages.removeNonDriver : messages.removeHHMember;
                    break;
                case 'excluded':
                    actionBtnLabel = messages.removeExcludedDriver;
                    break;
                default:
                    actionBtnLabel = commonMessages.mlContinue;
            }
        }

        const disableButton = () => {
            return _.isUndefined(_.get(driverVM, 'driverStatusForRemoving.value.code', undefined));
        };

        let originalSelectedOption = _.get(driverVM, 'driverStatusForRemoving.value.code');
        let clickedReasonOnce = false;

        const componentProps = {
            title: removeDriverModalTitle,
            uiProps: removeDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: actionBtnLabel,
            cancelBtnLabel: commonMessages.mlCancel,
            modalBodyStyles: removeDriverModalBodyStyles,
            discardChangesOnCancel: true,
            disableButton: disableButton,
            viewModelService,
            onSaveAction: (driverToRemove) => !canExcludeDrivers ? onRemoveDriverCannotExclude(driverToRemove, originalDriver) : onRemoveDriver(driverToRemove, originalDriver),
            getOverrideProps: () => {
                const currentSelectedOption = _.get(driverVM, 'driverStatusForRemoving.value.code');
                // Errors should not be visible until the user has change the option at least once.
                if (!clickedReasonOnce && originalSelectedOption !== currentSelectedOption) {
                    originalSelectedOption = "not-an-option";
                    clickedReasonOnce = true;
                }
                const validation = validateRemovalReason(driverVM);
                return {
                    validationErrorMessage: {
                        content: validation,
                        className: styles.removeDriverErrorMessage
                    },
                    errorNotification: {
                        visible: validation !== undefined && clickedReasonOnce
                    },
                    relationshipRow: {
                        visible: false
                    },
                    reason: {
                        path: "driverStatusForRemoving",
                        label: translator({ ...messages.reasonForRemove, args: { item: driverName, strong: (chunks) => <strong>{chunks}</strong> } }),
                        availableValues: isModernProduct ? getUmbrellaRemoveDriverOptions() : getRemoveDriverExcludedOptions(!canExcludeDrivers)
                    },
                    driverGender: {
                        visible: !isModernProduct
                    }
                };
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const onDriverEdit = (driver) => {
        const driverVM = viewModelService.clone(driver);
        updateRecentlyAddedDriver(driverVM);
        updateDriverEditedOriginal(driver);
        openDriverModal(driverVM, true, driver);
    };

    const onDriverRemove = (driver) => {
        const driverVM = viewModelService.clone(driver);
        updateRecentlyAddedDriver(driver);
        updateDriverEditedOriginal(driverVM);
        openRemoveDriverModal(driver, driverVM);
    };

    const onAddExcludedDriver = () => {
        const driverVM = addNewDriverModel('excluded');
        openExcludedDriverModal(driverVM, false);
    };

    const onExcludedDriverEdit = (driver) => {
        const driverVM = viewModelService.clone(driver);
        updateRecentlyAddedDriver(driverVM);
        updateDriverEditedOriginal(driver);
        openExcludedDriverModal(driverVM, true, driver);
    };

    const onAddHouseholdMember = () => {
        let driverVM ;
        if(isUMB_NP) {
            driverVM = addNewDriverModel('nondriver');
        } else{
            driverVM = addNewDriverModel('household');
        }
        openHouseholdMemberModal(driverVM, false);
    };

    const onHouseholdMemberEdit = (driver) => {
        const driverVM = viewModelService.clone(driver);
        updateRecentlyAddedDriver(driverVM);
        updateDriverEditedOriginal(driver);
        openHouseholdMemberModal(driverVM, true, driver);
    };

    // Redirect Function
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            let driverVM = {};
            const driverType = redirectAction.type;
            const action = redirectAction.action;
            if (redirectAction.model) {
                driverVM = pupModel.coverables.vehicleOperators.children.find((vm) => vm.publicID.value === redirectAction.model.publicID);
            }
            if (action === ACTION_ADD_DRIVER) {
                if (driverType === 'rated') {
                    onAddDriver();
                } else if (driverType === 'excluded') {
                    onAddExcludedDriver();
                } else if (driverType === 'household') {
                    onAddHouseholdMember();
                }
            } else if (action === ACTION_EDIT_DRIVER) {
                if (driverType === 'rated') {
                    onDriverEdit(driverVM);
                } else if (driverType === 'excluded') {
                    onExcludedDriverEdit(driverVM);
                } else if (driverType === 'household') {
                    onHouseholdMemberEdit(driverVM);
                }
            } else if (redirectAction.action === ACTION_REMOVE_DRIVER) {
                onDriverRemove(driverVM);
            }
        }
    };

    useEffect(() => {
        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML)) {
            handleStepAction(stepDataML);
            _.set(submissionVM, 'value.wizardActionDataML', {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    const nextStepText_Ext = () => {
        return <FormattedMessage
            {...messages.weWillReviewYourQuoteNext}
            values={{
                reviewAdditionalExposure: (
                    <strong>{translator(messages.reviewAdditionalExposure)}</strong>
                )
            }}
        />;
    };

    /*
     * We use this function to re-render the tablet and phone view of the table component, while making some changes on our own:
     *  ·We added to the table header a colon (:)
     *  ·We rearrenged the last row (action row) to match original.
     *  ·We added some horizontal rules between elements.
     */
    const renderTabletTable = (tabletTableProps) => {
        return (
            <div {...tabletTableProps}>
                {tabletTableProps.id === '0' && <hr />}
                <div {...tabletTableProps.children.props}>
                    <table {...tabletTableProps.children.props.children.props}>
                        <tbody {...tabletTableProps.children.props.children.props.children.props}>
                            {tabletTableProps.children.props.children.props.children.props.children.map((row, index, array) => {
                                if (index < (array.length - 1)) {
                                    return (
                                        <tr key={row.key} {...row.props}>
                                            <th {...row.props.children[0].props}>
                                                {row.props.children[0].props.children}:
                                            </th>
                                            <td {...row.props.children[1].props}>
                                                {row.props.children[1].props.children}
                                            </td>
                                        </tr>
                                    );
                                }
                                return (
                                    <tr key={row.key} {...row.props}>
                                        <td colSpan="42" className={styles.tabletActionRow}>
                                            {row.props.children[1].props.children.props.children}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <hr />
            </div>
        );
    };

    const getAccHoldeAgeIsValid = useCallback(() => {
        let accHolderName = _.get(submissionVM, 'baseData.accountHolder.displayFullName_Ext.value', '');
        let accHolderInVehOperator = submissionVM.value.lobData.personalUmbrella.coverables.vehicleOperators.filter((op) => op.displayName === accHolderName)[0];
        if(accHolderInVehOperator){
            let accHolderDOB = accHolderInVehOperator.contact.dateOfBirth
            let currDate = new Date();
            let accountHolderAge = moment(currDate).diff(accHolderDOB, 'years');
            if(accountHolderAge < ACCOUNTHOLDER_MIN_AGE){
                return false;
            }
        }
        return true;
    }, [submissionVM])

    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        const warningMissingExposureMessages = validateVehicleDriverDetailsExposures(pupModel);
        handleULPolicyAlerts(warningMissingExposureMessages);

        if(!getAccHoldeAgeIsValid()){
            addErrorAlert(translator(messages.accountHolderMinAge), 'accountHolderMinAge');
            window.scrollTo(0, 0);
            return false;
        }

        if (warningMissingExposureMessages.length === 0 && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid) {
            if (isReturnToQuote) {
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
            }

            return true;
        } else {
            window.scrollTo(0, 0);
            updateClickedOnNext(true);
            return false;
        }
    }, [authHeader, currentStep.mlStepName, handleULPolicyAlerts, pupModel, submissionVM, validateVehicleDriverDetailsExposures]);

    const onNext = useCallback(async () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Vehicle Exposure Page', action: 'Vehicle Exposure Submitted'});
            });
        }

        if (!submissionVM.value.isQuoted()) {
            _.unset(submissionVM.value, 'bindData');
        }
        setPrimaryNamedGender();
        clearExceptionErrors();

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        showProgressDialog(commonMessages.saveSubmission);
        try {
            const canSkipSave = steps.some((step) => step.mlStepName === 'pupWatercraftLocationBusinessDetails' && !!step.visited);
            if (!canSkipSave || returnToQuoteClicked) {
                const res = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
                submissionVM.value = res;
                updateWizardData(submissionVM);

                if (returnToQuoteClicked) {
                    MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
                    const zip = _.get(submissionVM, 'baseData.policyAddress.postalCode.value').substring(0, 5);
                    history.push('/quoteentry', {quoteID: submissionVM.quoteID.value, postalCode: zip, returnToQuoteFlag: 'true'});
                } else {
                    MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'pupWatercraftLocationBusinessDetails', authHeader);
                }
            }
            if (checkForQuestionUwIssues()) {
                return false;
            }
        } catch (error) {
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        } finally {
            hideProgressDialog(commonMessages.saveSubmission);
        }
        if (!nextStepVisited()) {
            return submissionVM;
        }

        goNext();
        return false;

    }, [isGPA, submissionVM, setPrimaryNamedGender, validateData, showProgressDialog, nextStepVisited, goNext, authHeader, steps, returnToQuoteClicked, LoadSaveService, updateWizardData, currentStep.mlStepName, history, hideProgressDialog, MLErrorMessageUtil]);

    const onReturnToQuoteClicked = useCallback(() => {
        returnToQuoteClicked = true;
        onNext();
    }, [onNext]);

    const overrides = {
        pageHeader: {
            visible: !isGPA
        },
        pageContainer: {
            className: isGPA ? classNames("page-content-gpa", styles.peStyles) : undefined
        },
        vehicleList: {
            data: pupModel.coverables.vehicles.children
        },
        driverList: {
            data: pupModel.coverables.vehicleOperators.children.filter((child) => child.driverType.value.code === 'rated')
        },
        hhMemberList: {
            data: pupModel.coverables.vehicleOperators.children.filter((child) => isHouseholdMemberOrNonDriver(child.driverType.value?.code))
        },
        householdMemberExcludedDriverSeparator: {
            visible: canExcludeDrivers
        },
        excludedDriverList: {
            data: pupModel.coverables.vehicleOperators.children.filter((child) => child.driverType.value.code === 'excluded'),
            visible: canExcludeDrivers
        },
        addExcludedDriverButtonContainer: {
            visible: canExcludeDrivers
        },
        addExcludedDriverButtonTooltip: {
            visible: isQnB
        },
        addExcludedDriverButton: {
            className: isQnB ? "margin-right-10 secondaryButton" : "margin-right-10"
        },
        stickyContinueSection: {
            visible: isGPA,
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext,
            showReturnToQuote,
            disableNext: disableNextButton
        },
        nextButton:{
            disabled: disableNextButton
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.quoteID.value,
            publicID: _.get(submissionVM, 'value.quotePublicId'),
            afterIssuesRefreshedCallback: checkForDisableNextButton
        },
        addHouseholdMemberButton: {
            content: isUMB_NP ? translator(messages.addNonDriver) : translator(messages.addHHMember)
        },
    };

    const resolvers = {
        resolveComponentMap: {
            MLAlertGroupComponent: MLAlertGroupComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveCallbackMap: {
            getFormattedDate,
            getTableField,
            getActionField,
            onDriverEdit,
            onDriverRemove,
            getVehicleTitle,
            getDriversTitle,
            getExcludedDriverTitle,
            getHouseholdMemberTitle,
            onAddVehicle,
            onAddDriver,
            onAddExcludedDriver,
            onAddHouseholdMember,
            getNameField,
            getVehicleNameField,
            getVehicleActionField,
            onVehicleEdit,
            onVehicleRemove,
            onNext,
            onHouseholdMemberEdit,
            onExcludedDriverEdit,
            renderTabletTable
        }
    };

    const skipOnResumeIf = () => {
        const vehicleOperatorsModelData = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicleOperators');

        const checkObjectValidity = (vom) => {
            if (vom && vom.children) {
                vom.children.forEach((item) => {
                    item.contact.isGenderRequired.value = true;
                    item.isRelationshipRequired.value = true;
                });
            }
        };

        checkObjectValidity(vehicleOperatorsModelData);

        if (vehicleOperatorsModelData && (
            vehicleOperatorsModelData?.aspects?.valid !== true ||
            vehicleOperatorsModelData?.aspects?.subtreeValid !== true
        )) {
            console.log('Stopping on Vehicles exposure Page becuase driver are not valid');
            return false;
        }

        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
            return false;
        }

        const warningMissingExposureMessages = validateVehicleDriverDetailsExposures(pupModel);
        if (warningMissingExposureMessages.length > 0) {
            return false;
        }

        return true;
    };

    return (
        <React.Fragment>
            <WizardPage
                showPrevious={false}
                showCancel={false}
                skipWhen={skipOnResumeIf}
                showNext={!nextStepVisited()}
                onNext={onNext}
                disableNext={disableNextButton}
                nextLabel={translator(commonMessages.mlContinue)}
                showTextNextToButton={!nextStepVisited()}
                textNextToButton={nextStepText_Ext()}
                metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
                showReturnToQuote={showReturnToQuote && canRequote}
                disableReturnToQuote={!canRequote || disableNextButton}
                updateWizardData={updateWizardData}
                validateData={validateData}
                history={history}
                onReturnToQuote={onReturnToQuoteClicked}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    model={submissionVM}
                    componentMap={resolvers.resolveComponentMap}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    onValidationChange={onValidate}
                    classNameMap={styles}
                />
            </WizardPage>
            {isVehiclePopupOpen && getVehiclePopup()}
            {isEditVehiclePopupOpen && getVehicleEditPopup()}
        </React.Fragment>
    );
};

VehicleDriverHouseHoldDetailsPage.propTypes = wizardProps;
export default withRouter(VehicleDriverHouseHoldDetailsPage);